import moment from 'moment';
import { useState, useEffect, useCallback } from 'react';
import ordenar from '../../functions/sort';
import { mascararCpf } from '../../functions/validateCPF';
import { Botao } from '../Botao';
import { Icone } from '../Icone';
import { Input } from '../Input';
import {
  ConteinerAcoes,
  BotaoPaginacao,
  Conteiner,
  TextoPaginacao,
  ConteinerFiltro,
  FormFiltro,
  AcoesPaginacao,
  ConteinerPaginacao,
  TabelaPrincipal,
  CabecalhoTabela,
  LinhaCabecalhoTabela,
  LinhaCorpoTabela,
  Td,
  AreaSuperior,
} from './styles';

export function Tabela({
  colunas = [],
  dados = [],
  aoMudarDePagina = null,
  totalDePaginas = 0,
  totalDeRegistros = 0,
  registrosPorPagina = 0,
  ordenarPor = '',
  ordenacaoDecresente = '',
  aoOrdenar = null,
  acoesDoRegistro = null,
  acoesDaTabela = null,
  comFiltro = false,
  selecionavel = false,
  chaveId = 'id',
  aoSelecionar,
  selecaoMultipla = false,
}) {
  const [busca, atribuirBusca] = useState('');
  const [colunasComFiltro] = useState([...colunas.filter((item) => item.filtrado)]);
  const [itens, atribuirItens] = useState(dados);
  const [pagina, atribuirPagina] = useState(1);
  const [selecionados, atribuirSelecionados] = useState([]);

  const filtrarItens = useCallback(
    (propriedade, decrescente) => {
      if (busca !== '') {
        const itensFiltrados = [...dados].filter((item) => {
          return Object.keys(item).some((obj) => {
            if (!colunasComFiltro.some((coluna) => coluna.propriedade === obj)) return false;
            if (obj !== 'id' && item[obj]?.includes(busca)) return true;
            else return false;
          });
        });

        return ordenar([...itensFiltrados], propriedade, decrescente);
      }
      if (!propriedade) {
        return [...dados];
      }
      return ordenar([...dados], propriedade, decrescente);
    },
    [dados, ordenacaoDecresente, ordenarPor, busca],
  );

  const alterarPagina = (novaPagina) => {
    if (novaPagina > totalDePaginas) return;
    if (novaPagina <= 0) return;

    atribuirPagina(novaPagina);
  };

  const obterIconeOrdenacao = (coluna) => {
    if (coluna.ordenavel) {
      if (ordenarPor && ordenarPor === coluna.propriedade) {
        if (ordenacaoDecresente) return <Icone nome='FaSortDown' tamanho={15} />;
        else return <Icone nome='FaSortUp' tamanho={15} />;
      } else return <Icone nome='FaSort' tamanho={15} />;
    } else return null;
  };

  const toggleSelecaoTodos = () => {
    if (selecionados.length < dados.filter((item) => !item.disabled).length) {
      atribuirSelecionados(dados.filter((item) => !item.disabled).map((item) => item[chaveId]));
    } else {
      atribuirSelecionados([]);
    }
  };

  const toggleSelecaoIndividual = (id) => {
    if (selecionados.includes(id)) {
      atribuirSelecionados(selecionados.filter((idSelecionado) => idSelecionado !== id));
    } else {
      atribuirSelecionados([...selecionados, id]);
    }
  };

  const aoMudarValorSelecionados = () => {
    if (aoSelecionar) {
      aoSelecionar(selecionados);
    }
  };

  const obterQuantidadeColunas = () => {
    let quantidadeColunas = colunas.length;
    if (selecionavel) {
      quantidadeColunas++;
    }
    if (acoesDoRegistro) {
      quantidadeColunas++;
    }
    return quantidadeColunas;
  };

  useEffect(() => {
    if (aoMudarDePagina) aoMudarDePagina(pagina);
  }, [pagina]);

  useEffect(() => {
    atribuirItens(filtrarItens(ordenarPor, ordenacaoDecresente));
  }, [busca]);

  useEffect(() => {
    atribuirItens(dados);
  }, [dados]);

  useEffect(() => {
    aoMudarValorSelecionados();
  }, [selecionados]);

  return (
    <Conteiner>
      <AreaSuperior>
        <div>{acoesDaTabela}</div>
        {comFiltro && (
          <ConteinerFiltro>
            <FormFiltro>
              <Input
                nome='search'
                titulo='Pesquisar'
                value={busca}
                aoAtribuirValor={atribuirBusca}
              />
            </FormFiltro>
          </ConteinerFiltro>
        )}
      </AreaSuperior>
      <TabelaPrincipal>
        <thead>
          <LinhaCabecalhoTabela>
            {selecionavel && (
              <CabecalhoTabela>
                <input
                  style={{ marginRight: '26%' }}
                  type='checkbox'
                  checked={selecionados.length === dados.length}
                  onChange={toggleSelecaoTodos}
                />
              </CabecalhoTabela>
            )}
            {colunas.map((coluna) => (
              <CabecalhoTabela key={coluna.nome} $largura={coluna.largura}>
                <ConteinerAcoes
                  onClick={() =>
                    coluna.ordenavel &&
                    aoOrdenar &&
                    aoOrdenar(coluna.propriedade, !ordenacaoDecresente)
                  }
                  $header
                >
                  {coluna.nome}
                  <div>{obterIconeOrdenacao(coluna)}</div>
                </ConteinerAcoes>
              </CabecalhoTabela>
            ))}
            {acoesDoRegistro ? <CabecalhoTabela>Ações</CabecalhoTabela> : null}
          </LinhaCabecalhoTabela>
        </thead>
        <tbody>
          {itens.length > 0 ? (
            itens.map((item, index) => (
              <LinhaCorpoTabela key={`row_body_${index}${item[chaveId]}`}>
                {selecionavel && (
                  <Td>
                    <input
                      type='checkbox'
                      checked={selecionados.includes(item[chaveId])}
                      onChange={() => toggleSelecaoIndividual(item[chaveId])}
                      disabled={item.disabled}
                    />
                  </Td>
                )}
                {colunas.map((coluna) =>
                  coluna.propriedade ? (
                    <Td key={coluna.propriedade}>
                      {coluna.data
                        ? moment(item[[coluna.propriedade]]).format('DD/MM/yyyy')
                        : coluna.mascara
                          ? mascararCpf(item[coluna.propriedade])
                          : coluna.booleano
                            ? item[coluna.propriedade] === true
                              ? 'Ativo'
                              : 'Inativo'
                            : item[coluna.propriedade] ?? '(sem informação)'}
                    </Td>
                  ) : null,
                )}
                {acoesDoRegistro ? (
                  <Td>
                    <ConteinerAcoes>
                      {acoesDoRegistro.map((acao, indice) => {
                        let campoDependencia = acao.campoDependencia ?? 'status';

                        if (
                          acao.valorDependencia === undefined ||
                          (Array.isArray(acao.valorDependencia) &&
                            acao.valorDependencia.includes(item[campoDependencia])) ||
                          acao.valorDependencia === item[campoDependencia]
                        )
                          return (
                            <Botao
                              key={indice}
                              outlined
                              cor={acao.cor}
                              desabilitado={selecaoMultipla || item.disabled}
                              aoClicar={() =>
                                acao.aoClicar(
                                  acao.retornarObjeto
                                    ? item
                                    : acao.posicao
                                      ? index
                                      : `${acao.redirecionar}${item.id}`,
                                  acao.retornarObjeto && acao.redirecionar
                                    ? acao.redirecionar
                                    : null,
                                )
                              }
                              dica={acao.tooltip}
                            >
                              <Icone nome={acao.icone} />
                            </Botao>
                          );
                      })}
                    </ConteinerAcoes>
                  </Td>
                ) : null}
              </LinhaCorpoTabela>
            ))
          ) : (
            <LinhaCorpoTabela>
              <Td colSpan={acoesDoRegistro ? colunas.length + 1 : colunas.length}>
                Nenhum registro
              </Td>
            </LinhaCorpoTabela>
          )}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={obterQuantidadeColunas()}>
              <ConteinerPaginacao>
                <TextoPaginacao>
                  Mostrando{' '}
                  {itens.length > 0
                    ? pagina === 1
                      ? 1
                      : (pagina - 1) * registrosPorPagina + 1
                    : 0}{' '}
                  até{' '}
                  {(pagina - 1) * registrosPorPagina + registrosPorPagina > totalDeRegistros
                    ? totalDeRegistros
                    : (pagina - 1) * registrosPorPagina + registrosPorPagina}{' '}
                  de {totalDeRegistros}
                </TextoPaginacao>
                <AcoesPaginacao>
                  <BotaoPaginacao onClick={() => alterarPagina(1)}>
                    <Icone nome='FaAngleDoubleLeft' />
                  </BotaoPaginacao>
                  <BotaoPaginacao onClick={() => alterarPagina(pagina - 1)}>
                    <Icone nome='FaAngleLeft' />
                  </BotaoPaginacao>
                  <BotaoPaginacao onClick={() => alterarPagina(pagina + 1)}>
                    <Icone nome='FaAngleRight' />
                  </BotaoPaginacao>
                  <BotaoPaginacao onClick={() => alterarPagina(totalDePaginas)}>
                    <Icone nome='FaAngleDoubleRight' />
                  </BotaoPaginacao>
                </AcoesPaginacao>
              </ConteinerPaginacao>
            </td>
          </tr>
        </tfoot>
      </TabelaPrincipal>
    </Conteiner>
  );
}
